import React, { useState, useEffect } from 'react'
import { BroadcastCon, ScheduleTableCon } from './weekStyles'
import { GameAction } from '../../../../Components/Buttons/GameAction'
import {
  getBroadcastImg,
  mapChampSeriesEvents,
  renderDateAndTime,
} from '../../../../Utils/Events/eventHelpers'
import { TeamsCol } from './TeamsCol'
import type { EventGQL } from '../../../../Api'
import { Head2 } from '../../../../Components/Typography/Text.styles'
import { BROADCASTER_LINKS } from '../../../../Config/config'
import { WLLCallout } from '../callouts/WLLCallout'
import { Lk } from '../../../../Components/Links/Lk'

type CSBoxParams = {
  week: string
  events: EventGQL[]
  showInET: boolean
}

type ChampEventObj = {
  [key: string]: EventGQL[]
}

export const ChampSeriesTable: React.FC<React.PropsWithChildren<CSBoxParams>> = ({
  events,
  showInET,
}) => {
  const [champEventObj, setChampEventObj] = useState<ChampEventObj>({
    roundRobin: [],
    semis: [],
    championship: [],
  })

  useEffect(() => {
    let mappedCSEvents = mapChampSeriesEvents(events)
    setChampEventObj(mappedCSEvents)
  }, [])

  const renderWLLCallout = (index: number) => {
    if (index === 3) {
      return (
        <td colSpan={4}>
          <WLLCallout />
        </td>
      )
    }
    return null
  }

  if (events.length === 0) {
    return <div />
  }

  return (
    <>
      <Head2 sideMargins={2}>Round Robin</Head2>
      <ScheduleTableCon>
        <tbody>
          {champEventObj.roundRobin.length > 0 &&
            champEventObj.roundRobin.map((event, idx) => (
              <>
                <tr key={event.slugname}>
                  <td>{renderDateAndTime(event.startTime, showInET)}</td>
                  <td>
                    <TeamsCol description={event.description} event={event} />
                  </td>
                  <td>
                    <BroadcastCon>
                      <Lk
                        link={event.urlStreaming || BROADCASTER_LINKS.generalESPNPlus}
                        alt="Broadcaster icons"
                      >
                        {getBroadcastImg(event.broadcaster).map((img, idx) => (
                          <img key={idx} className="broadcaster" src={img} alt="" />
                        ))}
                      </Lk>
                    </BroadcastCon>
                  </td>
                  <td>
                    {event.awayTeam && <GameAction event={event} section={'schedule'} />}
                  </td>
                </tr>
                <tr>{renderWLLCallout(idx)}</tr>
              </>
            ))}
        </tbody>
      </ScheduleTableCon>

      <Head2 sideMargins={2}>Semis</Head2>
      <ScheduleTableCon>
        <tbody>
          {champEventObj.semis.length > 0 &&
            champEventObj.semis.map((event) => (
              <tr key={event.slugname}>
                <td>{renderDateAndTime(event.startTime, showInET)}</td>
                <td>
                  <TeamsCol description={event.description} event={event} />
                </td>
                <td>
                  <BroadcastCon>
                    <Lk
                      link={event.urlStreaming || BROADCASTER_LINKS.generalESPNPlus}
                      alt="Broadcaster icons"
                    >
                      {getBroadcastImg(event.broadcaster).map((img, idx) => (
                        <img key={idx} className="broadcaster" src={img} alt="" />
                      ))}
                    </Lk>
                  </BroadcastCon>
                </td>
                <td>
                  {event.awayTeam && <GameAction event={event} section={'schedule'} />}
                </td>
              </tr>
            ))}
        </tbody>
      </ScheduleTableCon>

      <Head2 sideMargins={2}>Championship</Head2>
      <ScheduleTableCon>
        <tbody>
          {champEventObj.championship.length > 0 && (
            <tr key={champEventObj.championship[0].slugname}>
              <td>
                {renderDateAndTime(champEventObj.championship[0].startTime, showInET)}
              </td>
              <td>
                <TeamsCol
                  description={champEventObj.championship[0].description}
                  event={champEventObj.championship[0]}
                />
              </td>
              <td>
                <BroadcastCon>
                  <Lk
                    link={
                      champEventObj.championship[0].urlStreaming ||
                      BROADCASTER_LINKS.generalESPNPlus
                    }
                    alt="Broadcaster icons"
                  >
                    {getBroadcastImg(champEventObj.championship[0].broadcaster).map(
                      (img, idx) => (
                        <img key={idx} className="broadcaster" src={img} alt="" />
                      )
                    )}
                  </Lk>
                </BroadcastCon>
              </td>
              <td>
                {champEventObj.championship[0].awayTeam && (
                  <GameAction
                    event={champEventObj.championship[0]}
                    section={'schedule'}
                  />
                )}
              </td>
            </tr>
          )}
        </tbody>
      </ScheduleTableCon>
    </>
  )
}
